module.exports = __webpack_public_path__ + "img/light-bulb3.df74ce9b.svg";